import ClearingService from '../services/clearing.service'

export const clearingModule = {
  namespaced: true,

  state: {
    clearings: [],
    clearing: undefined,
    clearingDetail: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async search ({ commit }, criterias) {
      return ClearingService.search(criterias).then(
        response => {
          const clearings = response.data
          commit('searchSuccess', clearings)
          return Promise.resolve(clearings)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async get ({ commit }, id) {
      return ClearingService.get(id).then(
        response => {
          const clearing = response.data
          commit('getSuccess', clearing)
          return Promise.resolve(clearing)
        },
        error => {
          commit('getFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async resetClearing ({ commit }) {
      commit('clearingReset')
    },

    async resetDetail ({ commit }) {
      commit('clearingDetailReset')
    },

    async setClearingDetail ({ commit }, clearing) {
      commit('clearingSuccess', clearing)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    getSuccess (state, clearing) {
      state.clearing = clearing
    },
    getFailure (state) {
      state.clearing = undefined
    },
    listReset (state) {
      state.clearings = []
    },
    searchSuccess (state, clearings) {
      state.clearings = clearings
    },
    searchFailure (state) {
      state.clearings = []
    },
    clearingSuccess (state, clearing) {
      state.clearingDetail = clearing
    },
    clearingReset (state) {
      state.clearing = null
    },
    clearingDetailReset (state) {
      state.clearingDetail = null
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
